import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { STATES } from 'common/domain/states';
import { ROUTES } from 'common/domain/routes';

import cadastralReferenceMobileComponent from './cadastralReferenceMobile.component';
import modalQuestionCadastral from './modalQuestionCadastral/modalQuestionCadastral';

let cadastralReferenceMobileModule = angular.module('cadastralReferenceMobile', [
  uiRouter,
  modalQuestionCadastral
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state(STATES.LOANS.CADASTRAL_REFERENCE, {
      url: ROUTES.LOANS.CADASTRAL_REFERENCE,
      component: 'cadastralReferenceMobile',
      params: {
        dataParams: null,
      },
      data: {
        requiresAuth: true,
      }
    });
})

.component('cadastralReferenceMobile', cadastralReferenceMobileComponent)

.name;

export default cadastralReferenceMobileModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/cadastralReferenceMobile/cadastralReferenceMobile.js